var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.3335 15.8333V14.1666H5.00016V8.33329C5.00016 7.18052 5.34738 6.15621 6.04183 5.26038C6.73627 4.36454 7.63905 3.77774 8.75016 3.49996V1.66663H11.2502V3.49996C12.3613 3.77774 13.2641 4.36454 13.9585 5.26038C14.6529 6.15621 15.0002 7.18052 15.0002 8.33329V14.1666H16.6668V15.8333H3.3335ZM10.0002 18.3333C9.54183 18.3333 9.14947 18.1701 8.82308 17.8437C8.49669 17.5173 8.3335 17.125 8.3335 16.6666H11.6668C11.6668 17.125 11.5036 17.5173 11.1772 17.8437C10.8509 18.1701 10.4585 18.3333 10.0002 18.3333Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "notification-dot",
    cx: 15,
    cy: 5,
    r: 3.5,
    fill: "#FF0000",
    stroke: "#1E1E21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsActive);
export default __webpack_public_path__ + "static/media/notifications_active.bedb07f8307705ad37e652aad9ec9169.svg";
export { ForwardRef as ReactComponent };